import { getLocationIdentities } from './GetLocationIdentities';

/**
 * Identities Service
 * Provides business logic layer for organization-service identity operations
 */
export const IdentitiesService = {
  getLocationIdentities,
};
